import { BorderShape, borderShapeClasses } from "components/DesignSystem"

/**
 *  A class that determines the border shape class based on the passed border
 *  shape.
 */
export function determineBorderShapeClass(shape: BorderShape) {
  return borderShapeClasses[shape]
}
